import type { CheckoutLogRequest } from '~/models/checkout/CheckoutLogRequest';

export function checkout_sendCheckoutLogToBackend(
  store: CheckoutLogRequest['store'],
  step: CheckoutLogRequest['step'],
  message: CheckoutLogRequest['message'],
) {
  const { $api } = useNuxtApp();

  // Fire and forget, no await
  try {
    $api.checkout.logCheckoutData({
      store,
      step,
      message,
    });
  } catch (e) {
    // Do nothing if log call fails, so as to not interrupt the checkout
  }
}
